<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <TableSearchFilter
      :search="search"
      @search="updateSearch" 
      @showType="showType"
      :filters="[
    { key: 'settlement_type', type: 'select', required: true, props: { label: 'Settlement Type', items: settlementTypeitems } },
      ]"
    />
      <TableView
        :headers="headers"
        :items="allData"
        :options.sync="options"
        :loading="loading"
        :totalData="totalData"
        :customTopActions="true"
        :bodyFilter="true"
        item-key="id"
        table-height="70vh"
      >
      <template v-slot:top>
        <v-toolbar flat>
          <v-chip
            v-if="selectedData.length > 0"
            close
            @click:close="clearSelected"
          >
            {{ `${selectedData.length} data(s) selected` }}
          </v-chip>

          <v-spacer />
          <template>
            <v-btn
              color="primary"
              class="mb-2 rounded-pill elevation-0"
              @click="openSelectModal(true)"
              :style="{ 'margin-right': '10px' }"
              :disabled="loading"
              >Change Settlement Type
            </v-btn>
            <v-btn
            icon
            color="warning"
            class="mb-2"
            @click="getData"
            :style="{ 'margin-right': '10px' }"
            :loading="loading"
            :disabled="loading"
              ><v-icon>mdi-refresh</v-icon></v-btn
            >
          </template>
        </v-toolbar>
      </template>
      <template v-slot:body-prepend>
        <tr>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td
            class="pa-3 pl-4 d-block d-sm-table-cell d-print-table-cell fixed-row"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <v-checkbox
                    class="ma-0"
                    dense
                    hide-details="true"
                    v-model="selectAllData"
                    @click="selectAll(selectAllData)"
                  />
                </div>
              </template>
              <span>Select All</span>
            </v-tooltip>
          </td>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.merchant_type"
              :items="listMerchantType"
              label="Tipe Merchant "
              item-text="text"
              item-value="value"
              @change="searchFilter"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.mid"
              type="text"
              label="MID"
              v-on:keyup.enter="searchFilter"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
              clearable
              @click:clear="clearFilterData('mid')"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.nmid"
              type="text"
              label="NMID"
              v-on:keyup.enter="searchFilter"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
               clearable
              @click:clear="clearFilterData('nmid')"
            />
          </td>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />

          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.merchant_criteria"
              :items="listMerchantCriteria"
              label="Kriteria Merchant"
              item-text="text"
              item-value="value"
              @change="searchFilter"
              clearable
              hide-details="true"
              dense
            />
          </td>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-select
              v-model="search.qr_type"
              :items="listQrType"
              label="Jenis QR"
              item-text="text"
              item-value="value"
              @change="searchFilter"
              clearable
              hide-details="true"
              dense
            />
          </td>
        </tr>
      </template>
      <template v-slot:custom="{ item }">
        <v-checkbox
          class="ma-0"
          dense
          hide-details="true"
          v-model="selectedData"
          :value="item.id"
          :disabled="item.disable_status == 1"
        />
      </template>
      </TableView>

    <v-dialog v-model="selectStatus" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pt-3">
          Loading ...
          <v-progress-linear v-model="percentage" color="orange" height="15">
            <strong>{{ Math.ceil(percentage) }}%</strong>
          </v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirm" width="600" persistent>
      <confirm-dialog
        :title="
          'Semua merchant yang dipilih akan diubah menjadi settlement ' +
          (search.settlement_type === '1' ? 'H+0' : 'H+1')
        "
        v-on:closeCancelParent="close"
        v-on:confirmParent="changeType"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import {
  dataListMerchantCriteria,
  dataListPaymentType,
  dataListTrxType,
  dataQrMethod,
  dataAllQrType,
} from '../../store/params';
import { headers, editedItem, search, listMerchantType, settlementTypeitems } from '../../components/settlement-setting/attributes';
import { getDate, date, showAlert } from '../../lib/helpers';

export default {
  components: {
    confirmDialog: () => import('../../components/ConfirmDialog.vue'),
    
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
    TableSearchFilter: () => import("../../components/@drontVue/components/SearchFilter/TableSearchFilter.vue"),
  },
  data: () => ({
    options: {},
    show: false,
    dialog: false,
    dialogConfirm: false,
    expanded: [],
    headers,
    search,
    editedItem,
    defaultItem: {},
    selectedRow: '',
    searchAcquirer: '',
    searchIssuer: '',
    listPaymentType: dataListPaymentType,
    listTrxType: dataListTrxType,
    qrMethod: dataQrMethod,
    dateMenu: false,
    editedIndex: -1,
    selectedData: [],
    selectAllData: false,
    selectedStat: false,
    isFirstLoad: true,
    listMerchantType,
    settlementTypeitems,
    settlementType: null,
    listMerchantCriteria: dataListMerchantCriteria,
    listQrType: dataAllQrType,
  }),

  computed: {
    allData() {
      return this.$store.state.settlementSetting.allData;
    },
    totalData() {
      return this.$store.state.settlementSetting.totalData;
    },
    totalPage() {
      return this.$store.state.settlementSetting.totalPage;
    },
    loading() {
      return this.$store.state.settlementSetting.loading;
    },
    flashError: {
      get() {
        return this.$store.state.settlementSetting.flashError;
      },
      set() {
        this.$store.commit('settlementSetting/setFlashErrorMessage', '');
      },
    },
    flashErrorMessage() {
      return this.$store.state.settlementSetting.flashErrorMessage;
    },
    minDate() {
      return this.getDate(-7, date);
    },
    maxDate() {
      return date;
    },
    selectStatus() {
      return this.$store.state.settlementSetting.settlementStatus;
    },
    percentage() {
      return this.$store.state.settlementSetting.percentage;
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('settlementSetting/clearData');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },
    selectedData: {
      handler(newVal) {
        if (!Array.isArray(newVal)) return;
        this.checkAllSelected();
      },
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
  methods: {
    clearFilterData(field) {
      this.search[field] = ''; 
      this.getData(); 
    },
    selectRow(index) {
      if (this.selectedRow != index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },
    searchFilter(){
      this.options.page = 1;
      this.getData();
    },
    updateSearch(newSearch) {
      this.search.settlement_type = newSearch.settlement_type|| ''; 
      this.options.page = 1;
      if (newSearch.settlement_type === '') {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Settlement Type required !', 'mdi-alert', 'red');
      } else {
        this.getData();
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },


    showType(newSearch) {
      if ((!newSearch || !newSearch.settlement_type)) {
        this.$vuetify.goTo(0);
        showAlert(this.$store, 'Settlement Type required !', 'mdi-alert', 'red');
      } else {
        this.clearSelected();
        this.search.settlement_type = newSearch.settlement_type; 
        this.options.page = 1;
        this.getData(); 
      }
    },

    getData() {
      if (this.search.settlement_type == null) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'Settlement Type required !',
          'mdi-alert',
          'red'
        );
        // this.$store.commit("reconciliation/regenerateSettlement/clearSettlement")
      } else {
        this.$store.commit('settlementSetting/setFlashErrorMessage', '');
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store
          .dispatch('settlementSetting/getData', {
            date,
            page,
            itemsPerPage,
            sortBy,
            sortDesc,
            search: this.search,
          })
          .then(() => {
            if (this.totalPage < page) {
              if (this.totalPage == 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          })
          .finally(() => {
            this.checkAllSelected();
          });
      }
    },

    viewItem(item) {
      this.editedIndex =
        this.$store.state.settlementSetting.allData.indexOf(item);
      this.editedItem = { ...item };
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.dialogConfirm = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    closeFlash() {
      this.$store.commit('settlementSetting/setFlashErrorMessage', '');
    },

    clearSearch() {
      this.search.settlement_type = '';
      this.search.mid = '';
      this.search.nmid = '';
      this.search.merchant_criteria = '';
      this.search.qr_type = '';
      this.search.merchant_type = '';
      this.search.account_number = '';
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },

    clearSelected() {
      this.selectedData = [];
      this.selectAllData = false;
    },

    openSelectModal(selected) {
      this.selectedStat = selected;

      if (this.selectedStat && this.selectedData.length < 1) {
        showAlert(this.$store, 'Data must be selected!', 'mdi-alert', 'red');
      } else if (!this.selectedStat && this.allData.length < 1) {
        showAlert(this.$store, 'Data not found !', 'mdi-alert', 'red');
      } else {
        this.dialogConfirm = true;
      }
    },

    changeType() {
      this.dialogConfirm = false;
      const idData = this.selectedStat ? this.selectedData : null;

      this.$store
        .dispatch('settlementSetting/bulkSettlement', {
          date,
          id: idData,
          options: this.options,
          search: this.search,
        })
        .then(() => {
          this.clearSelected();
        });
    },

    selectAll(status) {
      this.$nextTick(() => {
        const allIds = [];

        this.allData.forEach((val) => {
          if (val.disable_status == 0) {
            allIds.push(val.id);
          }
          return allIds;
        });

        const filtered = allIds.filter(
          (val) => !this.selectedData.includes(val)
        );
        if (status) {
          this.selectedData = this.selectedData.concat(filtered);
        } else {
          this.selectedData = this.selectedData.filter(
            (val) => !allIds.includes(val)
          );
        }
      });
    },

    checkAllSelected() {
      const allIds = this.allData.map((val) => val.id);
      const allSelected = allIds.filter(
        (val) => !this.selectedData.includes(val)
      );
      if (
        allSelected.length == 0 &&
        this.selectedData.length > 0 &&
        this.allData.length > 0
      ) {
        this.selectAllData = true;
      } else {
        this.selectAllData = false;
      }
    },
    getDate,
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
